export default {
  user: JSON.parse(localStorage.getItem('user')) || undefined,
  isAuthenticated: false,
  jwt: localStorage.getItem('jwt') || null
}
